<template>
  <div class="products-component">

    <div class="row">
      <h2>Produtos</h2>

      <div class="col-md-3" v-for="prod in filterProducts(true)" @click="redirect(prod)" v-bind:key="prod.id">
        <div class="ibox-content text-center ssproduct enabled">
          <h3>{{ prod.name }}</h3>
          <div class="m-b-md">
            <img class="product-image" :title="prod.name" :src="prod.img">
          </div>

          <div class="text-center description-text">
            {{ prod.description }}
          </div>

          <div class="text-center bottomBtn">
            <button class="btn btn-success btn-block">Acessar {{ prod.name }}</button>
          </div>

        </div>
      </div>
    </div>

<!--     <div class="row">
      <h2>Outros produtos</h2>
      <div class="col-md-3" v-for="prod in filterProducts(false)" @click="redirect(prod)" v-bind:key="prod.id">
        <div class="ibox-content text-center ssproduct">
          <h3>{{ prod.name }}</h3>
          <div class="m-b-sm">
            <img class="product-image" :title="prod.name" :src="prod.img">
          </div>

          <div class="text-center description-text">
            {{ prod.description }}
          </div>

          <div class="text-center bottomBtn">
            <button class="btn btn-success btn-block">Saiba mais sobre {{ prod.name }}</button>
          </div>

        </div>
      </div>
    </div> -->

  </div>
</template>

<script>
  import { productSwitch } from '../mixins/product-switch'

  export default {
    mixins: [productSwitch],
    data () {
      return {
        products: []
      }
    },
    methods: {
      filterProducts(enabled) {
        return this.products.filter(product => product.enabled === enabled)
      },

      redirect(product, enable, id) {
        this.switchTo(product.id)
      }
    },
    mounted() {
      this.products = this.$data._products // pega os produtos do mixin
    }
  }
</script>

<style scoped>
  h2 { margin: 0 0 15px 15px; }
  div.wrapper { margin: 0px 30px; }
  div.col-md-3 {
    margin-bottom: 20px;
    max-width: 300px;
    min-width: 300px;
  }
  .ibox-content.text-center.ssproduct {
    min-height: 300px;
    max-height: 300px;
  }
  .ssproduct.enabled {
    cursor: pointer;
  }
  .ssproduct.enabled:hover { background-color: #fefefe; }

  .bottomBtn {
    position: absolute;
    bottom: 10px;
    width: 76%
  }

  .product-image {
    height: 65px;
    margin: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductsComponent.vue